import ProgressWidget from 'components/Dashboards/Widgets/ProgressWidget/ProgressWidget';
import BarWidget from 'components/Dashboards/Widgets/BarWidget/BarWidget';
import FunnelWidget from 'components/Dashboards/Widgets/FunnelWidget/FunnelWidget';
import LineWidget from 'components/Dashboards/Widgets/LineWidget/LineWidget';
import PieWidget from 'components/Dashboards/Widgets/PieWidget/PieWidget';
import StatsWidget from 'components/Dashboards/Widgets/StatsWidget/StatsWidget';
import PeriodsComparisonWidget
  from 'components/Dashboards/Widgets/PeriodsComparisonWidget/PeriodsComparisonWidget';
import KpiWidget from 'components/Dashboards/Widgets/KpiWidget/KpiWidget';

/**
 * this is list of widgets with parameters that will be compiled
 * when dashboard is loaded we use this prototypes
 * to compile widget object (using user defined params or default values from widgetTypes)
 * idea is that we are not storing complete dashboard on backend side, only configurable parameters
 * each widget consists of:
 *     type - by this field we match widget with its widget from widgetType
 *         and to determine which widget is stored in dashboard
 *     dsType - specifies data source type (get widget data from statistics or orders)
 *     dsStatistics[Orders]Params - parameters used by specified data source to build request for required data
 *     layout params - in prototype they specifies widget width and height,
 *         after compilation there will be position of widget
 *     component - this is widget component (vue)
 * @type {Array}
 */

const widgetPrototypes = [
  {
    type: 'metricChart',
    dsType: 'statistics',
    dsStatisticsParams: {
      sorting: {
        name: 'date',
        direction: 'asc'
      },
      dateGrouping: 'day',
      dateStart: '{dateStart}',
      dateEnd: '{dateEnd}',
      metrics: '{metrics}'
    },
    layoutParams: {
      w: 1,
      h: 1
    },
    component: StatsWidget
  },
  {
    type: 'barChart',
    dsType: 'statistics',
    dsStatisticsParams: {
      sorting: {
        name: 'date',
        direction: 'asc'
      },
      dateGrouping: 'no',
      grouping: '{grouping}',
      dateStart: '{dateStart}',
      dateEnd: '{dateEnd}',
      metrics: '{metrics}',
      channelIds: '{channelIds}',
      filteringType: '{filteringType}',
      filterEntities: '{filterEntities}'
    },
    layoutParams: {
      w: 1,
      h: 2
    },
    component: BarWidget
  },
  {
    type: 'pieChart',
    dsType: 'statistics',
    dsStatisticsParams: {
      sorting: {
        name: 'date',
        direction: 'asc'
      },
      dateGrouping: 'no',
      grouping: '{grouping}',
      dateStart: '{dateStart}',
      dateEnd: '{dateEnd}',
      metrics: '{metrics}',
      channelIds: '{channelIds}',
      filteringType: '{filteringType}',
      filterEntities: '{filterEntities}'
    },
    layoutParams: {
      w: 1,
      h: 2
    },
    component: PieWidget
  },
  {
    type: 'lineChart',
    dsType: 'statistics',
    dsStatisticsParams: {
      sorting: {
        name: 'date',
        direction: 'asc'
      },
      dateGrouping: 'day',
      grouping: '{grouping}',
      dateStart: '{dateStart}',
      dateEnd: '{dateEnd}',
      metrics: '{metrics}',
      metricsList: '{metricsList}',
      channelIds: '{channelIds}',
      filteringType: '{filteringType}',
      filterEntities: '{filterEntities}'
    },
    layoutParams: {
      w: 1,
      h: 2
    },
    component: LineWidget
  },
  {
    type: 'funnelChart',
    dsType: 'statistics',
    dsStatisticsParams: {
      sorting: {
        name: 'date',
        direction: 'asc'
      },
      dateGrouping: 'no',
      grouping: '{grouping}',
      dateStart: '{dateStart}',
      dateEnd: '{dateEnd}',
      metrics: '{metrics}',
      metricsList: '{metricsList}',
      channelIds: '{channelIds}',
      filteringType: '{filteringType}',
      filterEntities: '{filterEntities}'
    },
    layoutParams: {
      w: 1,
      h: 2
    },
    component: FunnelWidget
  },
  {
    type: 'periodsComparisonChart',
    dsType: 'statistics',
    dsStatisticsParams: {
      sorting: {
        name: 'date',
        direction: 'asc'
      },
      dateGrouping: 'day',
      grouping: 'no',
      dateStart: '{dateStart}',
      dateEnd: '{dateEnd}',
      metrics: '{metrics}',
      channelIds: '{channelIds}',
      filteringType: '{filteringType}',
      filterEntities: '{filterEntities}',
      periods: '{periods}'
    },
    layoutParams: {
      w: 1,
      h: 2
    },
    component: PeriodsComparisonWidget
  },
  {
    type: 'kpiChart',
    dsType: 'statistics',
    dsStatisticsParams: {
      sorting: {
        name: 'date',
        direction: 'asc'
      },
      dateGrouping: 'no',
      grouping: 'no',
      dateStart: '{dateStart}',
      dateEnd: '{dateEnd}',
      metrics: '{metrics}',
      planFactMetrics: '{planFactMetrics}',
      channelIds: '{channelIds}',
      filteringType: '{filteringType}',
      filterEntities: '{filterEntities}',
      customPeriod: '{customPeriod}'
    },
    layoutParams: {
      w: 1,
      h: 2
    },
    component: KpiWidget
  },
  {
    type: 'orderProgressTable',
    dsType: 'orders',
    dsOrdersParams: {
      dateStart: '{dateStart}',
      dateEnd: '{dateEnd}',
      orderGrouping: '{orderGrouping}',
      channels: '{channels}'
    },
    layoutParams: {
      w: 1,
      h: 2
    },
    component: ProgressWidget
  }
];

export default widgetPrototypes;
